import { API_URL } from '../config';
import { apiFetch, logout } from './auth';
import { getRangiDeviceId } from './deviceId';

export async function checkCurrentDeviceLicense() {
  const deviceId = getRangiDeviceId();

  try {
    const res = await apiFetch(`${API_URL}/license/check-device`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        device_id: deviceId,
      }),
    });

    if (!res.ok) {
      return {
        allowed: false,
        reason: 'LICENSE_CHECK_FAILED',
        status: res.status,
      };
    }

    return await res.json();
  } catch {
    return {
      allowed: false,
      reason: 'LICENSE_CHECK_NETWORK_ERROR',
    };
  }
}

export async function logoutIfCurrentDeviceLicenseDenied() {
  const result = await checkCurrentDeviceLicense();

  if (result?.allowed === false && result?.reason === 'DEVICE_LIMIT_EXCEEDED') {
    logout('license_limit_exceeded');
    return true;
  }

  if (result?.allowed === false && result?.reason === 'LICENSE_INVALID') {
    logout('license_invalid');
    return true;
  }

  return false;
}